export default {
  data() {
    return {
      timeRemaining: 0,
      intervalId: null,
    };
  },
  
  beforeDestroy() {
    this.clearTimer();
  },
  
  mounted() {
    this.checkTimer();
  },
  
  methods: {
    startExportTimer(storageKey = 'exportEndTime') {
      const duration = 60;
      const endTime = Date.now() + duration * 1000;
      
      localStorage.setItem(storageKey, endTime);
      
      this.timeRemaining = duration;
      this.startCountdown(storageKey);
    },
    
    startCountdown(storageKey) {
      this.clearTimer();
      
      this.intervalId = setInterval(() => {
        const endTime = localStorage.getItem(storageKey);
        if (endTime) {
          const remaining = Math.ceil((endTime - Date.now()) / 1000);
          
          if (remaining > 0) {
            this.timeRemaining = remaining;
          } else {
            this.timeRemaining = 0;
            this.clearTimer();
            localStorage.removeItem(storageKey);
          }
        } else {
          this.timeRemaining = 0;
          this.clearTimer();
        }
      }, 1000);
    },
    
    checkTimer(storageKey = 'exportEndTime') {
      const endTime = localStorage.getItem(storageKey);
      if (endTime) {
        const remaining = Math.ceil((endTime - Date.now()) / 1000);
        
        if (remaining > 0) {
          this.timeRemaining = remaining;
          this.startCountdown(storageKey);
        } else {
          this.timeRemaining = 0;
          localStorage.removeItem(storageKey);
        }
      }
    },
    
    clearTimer() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }
  }
};